// extracted by mini-css-extract-plugin
export default {"list":"menu_list__QgMug","item":"menu_item__5g1Z1","selected":"menu_selected__C246e","separator":"menu_separator__WnNcH","dark":"menu_dark__4Z8Mt","light":"menu_light__4EcIt"};